var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 7.25832H5.83333C6.29167 7.25832 6.66667 6.93169 6.66667 6.53249V0.725832C6.66667 0.326624 6.29167 0 5.83333 0H0.833333C0.375 0 0 0.326624 0 0.725832V6.53249C0 6.93169 0.375 7.25832 0.833333 7.25832ZM0.833333 13.065H5.83333C6.29167 13.065 6.66667 12.7383 6.66667 12.3391V9.43581C6.66667 9.0366 6.29167 8.70998 5.83333 8.70998H0.833333C0.375 8.70998 0 9.0366 0 9.43581V12.3391C0 12.7383 0.375 13.065 0.833333 13.065ZM9.16667 13.065H14.1667C14.625 13.065 15 12.7383 15 12.3391V6.53249C15 6.13328 14.625 5.80665 14.1667 5.80665H9.16667C8.70833 5.80665 8.33333 6.13328 8.33333 6.53249V12.3391C8.33333 12.7383 8.70833 13.065 9.16667 13.065ZM8.33333 0.725832V3.62916C8.33333 4.02837 8.70833 4.35499 9.16667 4.35499H14.1667C14.625 4.35499 15 4.02837 15 3.62916V0.725832C15 0.326624 14.625 0 14.1667 0H9.16667C8.70833 0 8.33333 0.326624 8.33333 0.725832Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.a21eea79.svg";
export { ForwardRef as ReactComponent };